import { clearValue, getValue, setValue } from "./local_storage";

export const setCsrfTokenKeyValue = (keyName, keyValue, valueName, valueValue) => {
    setValue('csrf-token-key-value', {
        keyName,
        keyValue,
        valueName,
        valueValue,
    });
};

export const removeCsrfTokenKeyValue = () => clearValue('csrf-token-key-value');

export const getCsrfTokenKeyParamName = () => getValue('csrf-token-key-value')?.keyName || '';

export const getCsrfTokenKey = () => getValue('csrf-token-key-value')?.keyValue || '';

export const getCsrfTokenValueParamName = () => getValue('csrf-token-key-value')?.valueName || '';

export const getCsrfTokenValue = () => getValue('csrf-token-key-value')?.valueValue || '';

export const getCsrfTokenQueryParam = () => {
    // csrfTokenKey=xxxx&csrfTokenValue=yyyy
    if (isCsrfTokenExists()) {
        return `${getCsrfTokenKeyParamName()}=${getCsrfTokenKey()}&${getCsrfTokenValueParamName()}=${getCsrfTokenValue()}`;
    }

    return null;
};

export const isCsrfTokenExists = () => {
    return getCsrfTokenKeyParamName();
};

export const updateCSRFTokenFromHeader = (request) => {
    const isRefetchRequired = request.getResponseHeader('X-Csrf-Token') === 'refetch';
    if (isRefetchRequired) {
        removeCsrfTokenKeyValue();
        location.reload();
    }
};